import { PriceFreezeOffer } from "@b2bportal/air-shopping-api";
import {
  Airport,
  Offer,
  PriceFreezeOfferDataResponse,
  TripDetailsV2,
} from "@b2bportal/price-freeze-api";
import { PassengerTypes } from "@hopper-b2b/types";
import {
  PassengerMap,
  AirPriceFreezePurchaseStateEnum,
  IContactInfo,
} from "../../../../../types";

export interface AirPriceFreezeOfferContext {
  priceFreezeOfferData?: PriceFreezeOfferDataResponse;
  priceFreezeOfferDataIndex: number;
  priceFreezeOffer?: Offer;
}

export const AirPriceFreezeOfferInitialContext: AirPriceFreezeOfferContext = {
  priceFreezeOfferData: undefined,
  priceFreezeOfferDataIndex: 0,
  priceFreezeOffer: undefined,
};

export interface AirPriceFreezeContext {
  flightShop: {
    tripDetails?: TripDetailsV2;
    tripId?: string;
    fareId?: string;
    airports?: { [key: string]: Airport };
  };
  contactInformation?: IContactInfo;
  passengerMap: PassengerMap;
  defaultPriceFreezeOffer?: PriceFreezeOffer;
  [AirPriceFreezePurchaseStateEnum.priceFreezeOffer]: AirPriceFreezeOfferContext;
}

export const getAirPriceFreezeInitialContext = (): AirPriceFreezeContext => ({
  flightShop: {
    tripDetails: undefined,
    tripId: undefined,
    fareId: undefined,
    airports: undefined,
  },
  passengerMap: { [PassengerTypes.Adult]: 1 },
  defaultPriceFreezeOffer: undefined,
  [AirPriceFreezePurchaseStateEnum.priceFreezeOffer]: {
    ...AirPriceFreezeOfferInitialContext,
  },
});
